import { Observable } from 'rxjs';
import { Article } from '../model/article';

export abstract class ArticleService {

  constructor() { }

  public abstract getByBarCode(barCode: string): Observable<Article | null>;
}
